import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { PeekBox, PeekChip, PeekList, PeekListItem, PeekListItemText, PeekTooltip, PeekTypography, } from "@piiqtechnologies/ui-components";
const AccessDevicesSpacesCellTooltip = ({ spaces, showBuildingName }) => {
    return (React.createElement(PeekList, { disablePadding: true }, spaces.map((space) => {
        return (React.createElement(PeekListItem, { disablePadding: true, key: space._id },
            React.createElement(PeekListItemText, { primary: React.createElement(PeekTypography, null,
                    "\u2022",
                    " ",
                    (showBuildingName && space.building.name && `${space.building.name}-${space.unit}`) || space.unit), primaryTypographyProps: { variant: "body1" } })));
    })));
};
export function AccessDevicesSpacesCell({ spaces, showBuildingName }) {
    const intl = useIntl();
    return (React.createElement(PeekTooltip, { placement: "bottom-start", title: React.createElement(AccessDevicesSpacesCellTooltip, { showBuildingName: showBuildingName, spaces: spaces }), disableHoverListener: !(spaces === null || spaces === void 0 ? void 0 : spaces.length) },
        React.createElement(PeekBox, null,
            React.createElement(PeekChip, { variant: "filled", label: `${spaces === null || spaces === void 0 ? void 0 : spaces.length} ${intl.formatMessage(messages.associatedToUnits)}`, sx: {
                    "&.MuiChip-filledDefault": { backgroundColor: (spaces === null || spaces === void 0 ? void 0 : spaces.length) ? "primary.contrastText" : "info.light" },
                } }))));
}
